<template>

        <v-dialog
                v-model="dialog"
                hide-overlay
                width="auto "
                :fullscreen="$vuetify.breakpoint.xsOnly"
                transition="dialog-bottom-transition"
        >
            <template v-slot:activator="{ on, attrs }">
                <v-btn
                    color="primary"
                    v-bind="attrs"
                    v-on="on"
                    @click="startNote"
                >
                    Submit note
                </v-btn>
            </template>
            <v-card style="min-width: 450px">
                <v-toolbar dark color="primary">
                    <v-spacer></v-spacer>
                    <v-toolbar-title>Add new note</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-toolbar-items>
                        <v-btn dark text @click="dialog = false">
                            <v-icon>mdi-close</v-icon>
                        </v-btn>
                    </v-toolbar-items>
                </v-toolbar>

                <v-container class="grey lighten-5" style="padding-left: 10%; padding-right: 10%">
                    <v-row>
                        <v-textarea
                                v-model="note"
                                label="Add note"
                        ></v-textarea>
                    </v-row>
                    <v-row align="center" justify="center">
                        <v-btn
                                color="secondary"
                                text
                                @click="close"
                        >
                            Cancel
                        </v-btn>
                        <v-btn
                                color="primary"
                                text
                                @click="submitNote"
                        >
                            Save
                        </v-btn>
                    </v-row>
                </v-container>
            </v-card>
        </v-dialog>

</template>

<script>
    import store from "@/store";
    import affiliatesApi from "@/api/affiliates";

    export default {
        data: () => ({
            dialog: false,
            note: ''
        }),
        props: {
            affiliate: Object,
            user: Object
        },
        async mounted() {

        },
        methods:{
          startNote() {
            this.dialog = true;
          },

          async submitNote() {
                const data = {
                  affiliateId: this.affiliate.id,
                  authorId: parseInt(this.user.employee_id),
                  note: this.note
                };

                console.log('data', data)

                try {
                    await affiliatesApi.createNote(data);
                    store.dispatch('alert/ALERT_SUCCESS', `Note has been created`, {root: true});
                    this.$emit('createNote', '')
                } catch (e) {
                    store.dispatch('alert/ALERT_ERROR', `An error has occurred.`, {root: true});
                }

                setTimeout(() => {
                    store.dispatch('alert/ALERT_REMOVE', ``, {root: true});
                }, 3000);


                this.dialog = false;
                this.cleanUp();
            },

          close() {
                this.cleanUp()
            },

            cleanUp() {
                this.dialog = false;
                this.note = '';
            }
        }
    }
</script>

<style scoped lang="sass">
</style>
